"use client";

import type { ReactNode } from "react";

import { WorkspaceSection } from "./workspace-shell";

type WorkspaceSectionBoundaryProps = {
  state?: ReactNode;
  children: ReactNode;
};

export function OnboardingWorkspaceSection({ state, children }: WorkspaceSectionBoundaryProps) {
  return (
    <WorkspaceSection ariaLabel="Onboarding" className="onboarding-page" state={state}>
      {children}
    </WorkspaceSection>
  );
}

export function DashboardWorkspaceSection({ state, children }: WorkspaceSectionBoundaryProps) {
  return (
    <WorkspaceSection ariaLabel="Workspace dashboard" className="workspace-view" state={state}>
      {children}
    </WorkspaceSection>
  );
}

export function ContactsWorkspaceSection({ state, children }: WorkspaceSectionBoundaryProps) {
  return (
    <WorkspaceSection ariaLabel="Contacts" className="wizard-grid" state={state}>
      {children}
    </WorkspaceSection>
  );
}

export function CampaignsWorkspaceSection({ state, children }: WorkspaceSectionBoundaryProps) {
  return (
    <WorkspaceSection ariaLabel="Campaigns" className="wizard-grid two" state={state}>
      {children}
    </WorkspaceSection>
  );
}

export function FunnelWorkspaceSection({ state, children }: WorkspaceSectionBoundaryProps) {
  return (
    <WorkspaceSection ariaLabel="Funnel Builder" className="workspace-view" state={state}>
      {children}
    </WorkspaceSection>
  );
}

export function TrackingWorkspaceSection({ state, children }: WorkspaceSectionBoundaryProps) {
  return (
    <WorkspaceSection ariaLabel="Tracking" className="workspace-view" state={state}>
      {children}
    </WorkspaceSection>
  );
}

export function InboxWorkspaceSection({ state, children }: WorkspaceSectionBoundaryProps) {
  return (
    <WorkspaceSection ariaLabel="Inbox" className="wizard-grid two" state={state}>
      {children}
    </WorkspaceSection>
  );
}

export function SettingsWorkspaceSection({ state, children }: WorkspaceSectionBoundaryProps) {
  return (
    <WorkspaceSection ariaLabel="Account settings" className="wizard-grid two" state={state}>
      {children}
    </WorkspaceSection>
  );
}
